export default __webpack_public_path__ + "static/media/anecdotes.f63ca5ea.svg";